import http from "../helpers/http";


export const getBusinessTypes = async (payload) => {
    const response = await http().get("/Merchant/GetBusinessTypes");
    return response.data;
};

export const requestLive = async (payload) => {
    const response = await http().post("/Merchant/RequestForGoLive", payload);
    return response.data;
};